const INDIVIDUAL_FILTER_DEFINITIONS = [
    {
        field: 'height_max',
        schema: 'reference.individuals',
        name: 'height',
        json: 'data',
        operator: '<=',
    },
    {
        field: 'height_min',
        schema: 'reference.individuals',
        name: 'height',
        json: 'data',
        operator: '>=',
    },
    {
        field: 'article',
        schema: 'reference.individuals',
        name: 'articles.article',
        json: 'data',
        target: 'articles',
    },
    {
        field: 'nickname',
        schema: 'reference.individuals',
        name: 'nickname',
        json: 'data',
    },
    {
        field: 'socialName',
        schema: 'reference.individuals',
        name: 'socialName',
        json: 'data',
    },
    {
        field: 'description',
        schema: 'reference.individuals',
        name: 'individualRegionWrapper.description',
        json: 'data',
    },
    {
        field: 'neighborhood',
        schema: 'reference.individuals',
        name: 'addresses.neighborhood',
        json: 'data',
        target: 'address',
    },
    {
        field: 'zipCode',
        schema: 'reference.individuals',
        name: 'addresses.zipCode',
        json: 'data',
        target: 'address',
    },
    {
        field: 'city',
        schema: 'reference.individuals',
        name: 'addresses.city',
        json: 'data',
        target: 'address',
    },
    {
        field: 'complement',
        schema: 'reference.individuals',
        name: 'addresses.complement',
        json: 'data',
        target: 'address',
    },
    {
        field: 'cnh',
        schema: 'reference.individuals',
        name: 'cnh',
        json: 'data',
    },
    {
        field: 'hairColor',
        schema: 'reference.individuals',
        name: 'hairColor',
        json: 'data',
    },
    {
        field: 'eyes',
        schema: 'reference.individuals',
        name: 'eyes',
        json: 'data',
    },
    {
        field: 'cpf',
        schema: 'reference.individuals',
        name: 'cpf',
        json: 'data',
    },
    {
        field: 'color',
        schema: 'reference.individuals',
        name: 'color',
        json: 'data',
    },
    {
        field: 'maritalStatus',
        schema: 'reference.individuals',
        name: 'maritalStatus',
        json: 'data',
    },
    {
        field: 'roleCrime',
        schema: 'reference.individuals',
        name: 'roleCrime',
        json: 'data',
    },
    {
        field: 'dtBirth_min',
        schema: 'reference.individuals',
        name: 'dtBirth',
        json: 'data',
        operator: '>=',
    },
    {
        field: 'dtBirth_max',
        schema: 'reference.individuals',
        name: 'dtBirth',
        json: 'data',
        operator: '<=',
    },
    {
        field: 'information',
        schema: 'reference.individuals',
        name: 'information',
        json: 'data',
    },
    {
        field: 'address',
        schema: 'reference.individuals',
        name: 'addresses.address',
        json: 'data',
        target: 'address',
    },
    {
        field: 'mother',
        schema: 'reference.individuals',
        name: 'mother',
        json: 'data',
    },
    {
        field: 'nationality',
        schema: 'reference.individuals',
        name: 'nationality',
        json: 'data',
    },
    {
        field: 'cityOfBirth',
        schema: 'reference.individuals',
        name: 'cityOfBirth',
        json: 'data',
    },
    {
        field: 'name',
        schema: 'reference.individuals',
        name: 'name',
        json: 'data',
    },
    {
        field: 'father',
        schema: 'reference.individuals',
        name: 'father',
        json: 'data',
    },
    {
        field: 'indHasOccurrence',
        name: 'indHasOccurrence'
    },
    {
        field: 'hasSos',
        name: 'hasSos'
    },
    {
        field: 'hasEncounter',
        name: 'hasEncounter'
    },
    {
        field: 'hasBos',
        name: 'hasBos'
    },
    {
        field: 'rg',
        schema: 'reference.individuals',
        name: 'rg',
        json: 'data',
    },
    {
        field: 'situation',
        schema: 'reference.individuals',
        name: 'situation',
        json: 'data',
    },
    {
        field: 'sex',
        schema: 'reference.individuals',
        name: 'sex',
        json: 'data',
    },
    {
        field: 'phone',
        schema: 'reference.individuals',
        name: 'phones.data',
        json: 'data',
        target: 'phone',
    },
    {
        field: 'alcoholDrugDependency',
        schema: 'reference.individuals',
        name: 'alcoholDrugDependency',
        json: 'data',
    },
    {
        field: 'mentalDisorder',
        schema: 'reference.individuals',
        name: 'mentalDisorder',
        json: 'data',
    },
    {
        field: 'bodyShape',
        schema: 'reference.individuals',
        name: 'bodyShape',
        json: 'data',
    },
    {
        field: 'hairType',
        schema: 'reference.individuals',
        name: 'hairType',
        json: 'data',
    },
    {
        field: 'isHomeless',
        name: 'isHomeless',
    },
    {
        field: 'individualReferral',
        name: 'individualReferral',
        json: 'data',
    },
    {
        field: 'occupation',
        schema: 'reference.individuals',
        name: 'occupation',
        json: 'data',
    },
    {
        field: 'educationDegree',
        schema: 'reference.individuals',
        name: 'educationDegree',
        json: 'data',
    },
    {
        field: 'socialNetwork',
        schema: 'reference.individuals',
        name: 'socialNetwork',
        json: 'data',
    },
    {
        field: 'associations',
        name: 'associations',
    },
]

export default INDIVIDUAL_FILTER_DEFINITIONS;